import { routeConstant } from "shared/routes/routeConstant";
import { useNavigate } from "react-router-dom";
import { Icons, Images } from "assets";
import CustomButton from "shared/components/common/customButton";
import styles from "./style.module.scss";

const Success = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className="flex flex-col gap-4">
          <div className={styles.iconWrapper}>
            <img src={Images.HomeImg} alt="home-img" />
          </div>
          <h2 className={styles.title}>Thank You!</h2>
          <h6>Your Onboarding is Complete!</h6>
          <p className={styles.message}>
            Your project details have been received. This helps our design team
            prepare your project and ensures your home design journey starts on
            the right track. You can now access your full project dashboard.
          </p>
        </div>
        <CustomButton
          title="Go to My Project Dashboard"
          onClick={() => navigate(routeConstant.client.projects.path)}
          containerStyle={styles.button}
          Icon={Icons.ChevRight}
          IconDirection="right"
        />
      </div>
    </>
  );
};

export default Success;
